import { gql, MutationTuple, TypedDocumentNode, useMutation } from "@apollo/client";

import type { Mutation, MutationSubmitAirQuoteArgs } from "../../../../../../api/types/generated-types";
import { useOnApolloError } from "../../../../../../hooks/useOnApolloError";

type MutationSubmitAirQuote = Pick<Mutation, "submitAirQuote">;

const SUBMIT_AIR_QUOTE: TypedDocumentNode<MutationSubmitAirQuote, MutationSubmitAirQuoteArgs> = gql`
  mutation ($input: SubmitAirQuoteInput!) {
    submitAirQuote(input: $input)
  }
`;

type UseMutationReturn = MutationTuple<MutationSubmitAirQuote, MutationSubmitAirQuoteArgs>;

type HookOptions = {
  onError?: () => Promise<void>;
};

type HookReturn = {
  submitAirQuote: UseMutationReturn[0];
  loading: UseMutationReturn[1]["loading"];
};

export const useSubmitAirQuote = ({ onError }: HookOptions): HookReturn => {
  const { onApolloError } = useOnApolloError({ componentName: "useSubmitAirQuote" });

  const [submitAirQuote, { loading }] = useMutation(SUBMIT_AIR_QUOTE, {
    onError: async (apolloError) => {
      onApolloError("submitAirQuote")(apolloError);
      await onError?.();
    },
  });

  return { submitAirQuote, loading };
};
